import { createAction } from 'redux-actions';

import dynaForms from '@elab/core/utils/dynaForms';

import getPersonalTypes from './types';

const createActions = storeName => {
    const personal = getPersonalTypes(storeName);
    const doAddressVerification = createAction(personal.DO_ADDRESS_VERIFICATION);
    const setShouldPrefill = createAction(personal.SHOULD_PREFILL_FORM);
    const setFakeValidation = createAction(personal.SET_FAKE_VALIDATION);
    const setSkipPhonePrefill = createAction(personal.SHOULD_PREFILL_PHONE);
    const preservePhoneNumberPattern = createAction(personal.PRESERVE_PHONE_NUMBER_PATTERN);
    return {
        ...dynaForms.getActions(storeName),
        doAddressVerification,
        setShouldPrefill,
        setFakeValidation,
        setSkipPhonePrefill,
        preservePhoneNumberPattern,
    };
};

export default createActions;
